import { render, staticRenderFns } from "./shopLogo.vue?vue&type=template&id=6aff7e46&scoped=true"
import script from "./shopLogo.vue?vue&type=script&lang=js"
export * from "./shopLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aff7e46",
  null
  
)

export default component.exports